import * as React from "react";

import type { VariantProps } from "class-variance-authority";

import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva } from "class-variance-authority";

import { cn } from "../../utils";

const toggleVariants = cva(
  "af-inline-flex af-items-center af-justify-center af-gap-2 af-rounded-md af-text-sm af-font-medium af-transition-colors focus-visible:af-outline-none disabled:af-pointer-events-none disabled:af-opacity-50 [&_svg]:af-pointer-events-none [&_svg]:af-shrink-0",
  {
    variants: {
      variant: {
        default:
          "af-bg-transparent af-text-foreground af-ring-offset-background hover:af-bg-muted hover:af-text-muted-foreground focus-visible:af-bg-accent focus-visible:af-text-accent-foreground data-[state=on]:af-bg-accent data-[state=on]:af-text-accent-foreground",
        outline:
          "af-border af-border-input af-bg-transparent hover:af-bg-muted hover:af-text-accent-foreground focus-visible:af-bg-accent focus-visible:af-text-foreground data-[state=on]:af-bg-accent data-[state=on]:af-text-accent-foreground",
        select:
          "af-border af-border-primary af-bg-secondary/20 af-text-primary hover:af-bg-secondary/50 hover:af-text-primary focus-visible:af-bg-secondary/50 focus-visible:af-text-primary data-[state=on]:af-bg-secondary/50 data-[state=on]:af-text-primary",
      },
      size: {
        default: "af-h-10 af-min-w-10 af-px-3 [&_svg]:af-size-4",
        xs: "af-h-6 af-min-w-7 af-px-1.5 [&_svg]:af-size-3.5",
        sm: "af-h-9 af-min-w-9 af-px-2.5 [&_svg]:af-size-4",
        lg: "af-h-11 af-min-w-11 af-px-5 [&_svg]:af-size-4",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Toggle = ({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) => (
  <TogglePrimitive.Root
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
);

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
